module.exports = __webpack_public_path__ + "static/media/image.a2839db9.svg";